import { Switch } from "@chakra-ui/react";

interface Props extends Switch.RootProps {
  checked: boolean;
  onChange: () => void;
}

function CustomSwitch({ checked, onChange, ...props }: Props) {
  return (
    <Switch.Root
      {...props}
      checked={checked}
      onCheckedChange={onChange}
      //colorPalette={colors.schoolAccent.primary}
    >
      <Switch.HiddenInput />
      <Switch.Control
       bg={"gray.emphasized"}
        
        
       _checked={{
         bg: "bg.inverted",
        
       }}
      >
        <Switch.Thumb />
      </Switch.Control>
      <Switch.Label />
    </Switch.Root>
  );
}

export default CustomSwitch;
